import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  ViewActivityEngagementRequest,
  ViewHashtagEngagementRequest,
  ViewHashtagOccurencesRequest
} from './administration.types';

import {
  requestViewActivityEngagement,
  requestViewHashtagEngagement,
  requestViewHashtagOccurrences
} from './administration.actions';

export const useAdministrationApi = () => {
  const dispatch = useDispatch();

  const viewActivityEngagement = useCallback(
    (requestData: ViewActivityEngagementRequest, onSuccess?: () => void) => {
      dispatch(requestViewActivityEngagement({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewHashtagEngagement = useCallback(
    (requestData: ViewHashtagEngagementRequest, onSuccess?: () => void) => {
      dispatch(requestViewHashtagEngagement({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewHashtagOccurrences = useCallback(
    (requestData: ViewHashtagOccurencesRequest, onSuccess?: () => void) => {
      dispatch(requestViewHashtagOccurrences({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { viewActivityEngagement, viewHashtagEngagement, viewHashtagOccurrences };
};
